var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tableComponent',{ref:"tableComponent",staticClass:"pa-5 mt-6",attrs:{"tableSettings":_vm.tableSettings,"tableData":_vm.tableData,"headers":_vm.headers},on:{"newDocument":_vm.newDocument}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }